import { Plane, Shield, Car, Award, Home, Briefcase, FolderOpen } from 'lucide-react';
import TabGrid from '@/components/ui/TabGrid';

/**
 * Documents Tab Configuration
 * Cool grey palette with subtle variations per tab
 */
const TAB_CONFIG = [
  {
    id: 'ids_travel',
    label: 'IDs & Travel',
    icon: Plane,
    colors: {
      bg: '#F0EFED',
      active: '#E5E4E1',
      text: '#4A4745',
      iconBg: '#E8E7E5',
    }
  },
  {
    id: 'insurance',
    label: 'Insurance',
    icon: Shield,
    colors: {
      bg: '#EEF0F2',
      active: '#E2E5E8',
      text: '#454B52',
      iconBg: '#E6E9EC',
    }
  },
  {
    id: 'car_registration',
    label: 'Car',
    icon: Car,
    colors: {
      bg: '#F2F0EE',
      active: '#E8E5E2',
      text: '#4D4A47',
      iconBg: '#EAE7E4',
    }
  },
  {
    id: 'licenses_certs',
    label: 'Licenses',
    icon: Award,
    colors: {
      bg: '#EFEEEC',
      active: '#E4E3E0',
      text: '#4A4947',
      iconBg: '#E7E6E4',
    }
  },
  {
    id: 'home_utilities',
    label: 'Home',
    icon: Home,
    colors: {
      bg: '#EFF1EF',
      active: '#E4E6E3',
      text: '#474A47',
      iconBg: '#E7E9E7',
    }
  },
  {
    id: 'work_school',
    label: 'Work',
    icon: Briefcase,
    colors: {
      bg: '#F0EEF1',
      active: '#E5E3E6',
      text: '#4A484C',
      iconBg: '#E8E6E9',
    }
  },
  {
    id: 'other',
    label: 'Other',
    icon: FolderOpen,
    colors: {
      bg: '#F0EFED',
      active: '#E5E4E1',
      text: '#4A4745',
      iconBg: '#E8E7E5',
    }
  }
];

const TABS_ORDER = ['ids_travel', 'insurance', 'car_registration', 'licenses_certs', 'home_utilities', 'work_school', 'other'];

/**
 * DocumentsTabs - Grid-based tab navigation for Documents module
 * All tabs visible at once - no scrolling, no hidden features
 */
const DocumentsTabs = ({ activeTab, onTabChange, children }) => {
  return (
    <TabGrid
      tabs={TAB_CONFIG}
      activeTab={activeTab}
      onTabChange={onTabChange}
      testIdPrefix="doc-tab"
    >
      {children}
    </TabGrid>
  );
};

export { TAB_CONFIG, TABS_ORDER };
export default DocumentsTabs;
